// locale for maze
import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

let locale = safeLoadLocale('maze_locale');
module.exports = locale;
